import React, { useState, useCallback } from 'react';
import { SingleDatePicker } from 'react-dates';
import { Moment } from 'moment';

import WpIcon from 'Wpds/components/icon/WpIcon';

import './CustomSingleDatePicker.scss';

type Props = {
  withPortal?: boolean;
  numberOfMonths?: number;
  date: Moment;
  onDateChange: Function;
};

const CustomSingleDatePicker = ({ onDateChange, date, withPortal = false, numberOfMonths = 1 }: Props) => {
  const [startsAtFocused, setStartsAtFocused] = useState(false);

  const handleDateChange = useCallback(
    momentDate => {
      if (momentDate) onDateChange(momentDate);
    },
    [onDateChange]
  );

  const handleStartsAtFocusedChange = useCallback(({ focused }) => setStartsAtFocused(focused), []);

  const handleCalendarIconClick = useCallback(() => setStartsAtFocused(true), []);

  return (
    <div className="CustomSingleDatePicker position-relative">
      <SingleDatePicker
        id="startsAtInput"
        numberOfMonths={numberOfMonths}
        date={date}
        withPortal={withPortal}
        focused={startsAtFocused}
        onDateChange={handleDateChange}
        onFocusChange={handleStartsAtFocusedChange}
        isOutsideRange={() => false}
        inputIconPosition="after"
        hideKeyboardShortcutsPanel
      />
      <span
        className="CustomSingleDatePicker__icon position-absolute text-primary cursor-pointer"
        onClick={handleCalendarIconClick}
      >
        <WpIcon name="calendar" />
      </span>
    </div>
  );
};

export default CustomSingleDatePicker;
